import React, { useState, useEffect } from "react";
import { Text, Divider, Col, Row, Typography, theme } from "antd";
import { ShopOutlined, PlusCircleFilled } from "@ant-design/icons";
import FactoryGeneralModal from "./FactoryGeneralModal";
import { GET } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import ColorButton from "../../../common/ColorButton";
import { dateToHumanString } from "../../../frameworks/Util";

const DeliverCompanyList = React.forwardRef(() => {
  const [openFactoryGeneralModal, setOpenFactoryGeneralModal] = useState(false);
  const [errorMessages, setErrorMessages] = useState(null);
  const [factoryData, setFactoryData] = useState(null);

  const Text = Typography;

  const {
    token: { colorWarning },
  } = theme.useToken();

  const fetchConfig = async () => {
    try {
      const response = await GET(URL_SETTING.CONFIG_FACTORY);
      if (response) {
        setFactoryData(response.data);
      } else {
        setErrorMessages("ไม่พบข้อมูลโรงงาน");
      }
    } catch (error) {
      setErrorMessages(
        error?.errorMessages || ["เกิดข้อผิดพลาดการโหลดข้อมูล"]
      );
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  const handleCloseModal = () => {
    setOpenFactoryGeneralModal(false);
  };

  if (errorMessages) {
    return <Text type="danger">{errorMessages}</Text>;
  }
  if (!factoryData) {
    return <Text>กำลังโหลดข้อมูล...</Text>;
  }

  return (
    <div>
      <Divider>โรงงาน</Divider>
      <Row gutter={[16, 24]} style={{ display: "flex", alignItems: "center", padding: "12px 0" }}>
        <Col span={12}>
          <Text strong>
            <ShopOutlined /> ชื่อโรงงาน
          </Text>
        </Col>
        <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Text>{factoryData.NAME_TH}</Text>
        </Col>

        <Col span={12}>
          <Text strong>
            <ShopOutlined /> เลขประจำตัวผู้เสียภาษี
          </Text>
        </Col>
        <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Text>{factoryData.INVOICE_ID }</Text>
        </Col>

        <Col span={12}>
          <Text strong>
            <ShopOutlined /> ที่อยู่
          </Text>
        </Col>
        <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Text>{factoryData.ADDRESS_TH}</Text>
        </Col>
      </Row>

      <Divider>ใบอนุญาตค้ายาง</Divider>
      <Row gutter={[16, 24]} style={{ display: "flex", alignItems: "center", padding: "12px 0" }}>
        <Col span={12}>
          <Text strong>
            <ShopOutlined /> เลขที่ใบอนุญาตค้ายาง
          </Text>
        </Col>
        <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Text>{factoryData.LICENSE_NUMBER}</Text>
        </Col>

        <Col span={12}>
          <Text strong>
            <ShopOutlined /> วันที่ใบอนุญาตหมดอายุ
          </Text>
        </Col>
        <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Text>{dateToHumanString(factoryData.LICENSE_EXPIRE_DATE)}</Text>
        </Col>

        <Col span={12}>
          <Text strong>
            <ShopOutlined /> ที่อยู่ตามใบอนุญาตค้ายาง
          </Text>
        </Col>
        <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Text>{factoryData.LICENSE_ADDRESS}</Text>
        </Col>
      </Row>

      <div style={{ display: "flex", justifyContent: "center", marginBottom: 10, marginTop: 20 }}>
        <ColorButton
          type="primary"
          override={colorWarning}
          icon={<PlusCircleFilled />}
          onClick={() => setOpenFactoryGeneralModal(true)}
        >
          แก้ไขข้อมูล
        </ColorButton>
      </div>

      <FactoryGeneralModal
        open={openFactoryGeneralModal}
        onClose={handleCloseModal}
        onUpdate={() => {
          setOpenFactoryGeneralModal(false);
          fetchConfig();
        }}
        factoryData={factoryData}
      />
    </div>
  );
});

export default DeliverCompanyList;
